import { FormGroup } from "@angular/forms";

import { EstimateActionsEnum } from "../../../../../models/enum/estimate-actions.enum";
import { SplitCategory } from "@bitwarden/web-vault/app/models/data/shared/split-category/split-category";
import { SplitClassificationType } from "../../../../../models/types/split-classification-type";

export class FormHelper {
  getTransactionGenerator(estimateFormGroup: FormGroup) {
    const recurring = estimateFormGroup.controls["isRecurring"].value;
    const transactionGenerator = estimateFormGroup.controls["calculateAs"].value.key;
    if (transactionGenerator) {
      return transactionGenerator;
    }
    let generator = EstimateActionsEnum.nonRecurring;
    if (recurring) {
      if (transactionGenerator) {
        generator = transactionGenerator;
      } else {
        generator = EstimateActionsEnum.recurringFixed;
      }
    }
    return generator;
  }

  getCalculationMethod(estimateFormGroup: FormGroup) {
    const isRecurring = estimateFormGroup.controls["isRecurring"].value;

    if (isRecurring === "Yes") {
      return {
        name: "Recurring Fixed",
        key: EstimateActionsEnum.recurringFixed,
      };
    }

    return {
      name: "Non-Recurring",
      key: EstimateActionsEnum.nonRecurring,
    };
  }

  generateSplitCategoriesFromForm(estimateFormGroup: FormGroup): SplitCategory[] {
    const splitCategories: SplitCategory[] = [];
    for (const key in estimateFormGroup.controls) {
      if (key.startsWith("category")) {
        const value = estimateFormGroup.controls[key].value;
        const keySplits = key.split("_");
        if (value !== 0 && keySplits[1]) {
          const splitCategory = new SplitCategory();
          splitCategory.categoryLink.id = keySplits[1];
          splitCategory.weight = value;
          splitCategory.roundingDefault = false;
          splitCategories.push(splitCategory);
        }
      }
    }

    return splitCategories;
  }

  generateSplitClassificationsFromForm(estimateFormGroup: FormGroup): SplitClassificationType[] {
    const splitClassifications: SplitClassificationType[] = [];
    for (const key in estimateFormGroup.controls) {
      if (key.startsWith("classification")) {
        const value = estimateFormGroup.controls[key].value;
        const keySplits = key.split("_");
        if (value !== 0 && keySplits[1]) {
          splitClassifications.push({
            classificationId: keySplits[1],
            weight: value,
            roundingDefault: false,
          });
        }
      }
    }
    return splitClassifications;
  }
}
